import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'MATCH_TXN_DIALOG';

interface MatchTxnDialogProps {
  txn: any;
  transactions?: any;
  wrapperId?: string;
}

export const showMatchTxnDialog = createAction(rootUiActions.createDialog.toString(), (props: MatchTxnDialogProps) =>
  rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
    id: DIALOG_TYPE,
    allowNesting: true,
    props: ImmutableMap(props),
  }),
);
